import {$} from '../util/view'
import CMPError from '../cmp-error'
import API, {SimpleCallback} from './api'
import BackendAPI from './backend'
import IFrontendAPI, {requiresView} from './frontend-interface'
import ConsentModModel from '../model/consent-mod'
import consentFactory from '../model/consent-factory'
import {AppView} from '../view/app'
import {onContentLoaded} from '../util/dom'

export default class FrontendModAPI extends BackendAPI implements IFrontendAPI {
  public static async load (baseURL: string): Promise<FrontendModAPI> {
    const {document: doc} = window

    const iframe = $('iframe', {
      id: 'mol-ads-cmp-iframe',
      name: '__cmpLocation',
      style: 'width:0;height:0;border:none;'
    }, [], doc).raw as HTMLIFrameElement

    const promise = new Promise((resolve, reject) => {
      const onLoad = async () => {
        const {contentWindow} = iframe

        iframe.removeEventListener('load', onLoad)

        if (!contentWindow) {
          reject(new CMPError('Couldn\'t successfully create CMP'))
        }

        resolve(new this(baseURL))
      }

      iframe.addEventListener('load', onLoad)
      iframe.addEventListener('error', reject)

      onContentLoaded(() => doc.body.appendChild(iframe))
    })

    return Promise
      .all([promise, super.load(baseURL)])
      .then(([, api]): FrontendModAPI => {
        (api as FrontendModAPI).iframe = iframe
        return api as FrontendModAPI
      })
  }

  public view?: AppView
  public iframe?: HTMLIFrameElement

  public async init (): Promise<void> {
    this.consentModel = await consentFactory(this.baseURL, ConsentModModel)
    this.isReady = true
    this.emit('ready')
  }

  public consentToAll (origin: string = location.origin, callback: SimpleCallback = () => {}): Promise<void> {
    return super.consentToAll(origin, callback)
  }

  public dissentToAll (origin: string = location.origin, callback: SimpleCallback = () => {}): Promise<void> {
    return super.dissentToAll(origin, callback)
  }

  @requiresView
  public openSettings (_: null, callback: SimpleCallback) {
    this.view!.openSettings()
    callback(null, true)
  }

  @requiresView
  public giveThanks (_: null, callback: SimpleCallback) {
    this.view!.alert()
    callback(null, true)
  }

  public rendered (_: null, callback: SimpleCallback, count: number = 0) {
    if (this.view) {
      callback(null, true)
    } else if (count > 10) {
      callback(null, false)
    } else {
      setTimeout(() => this.rendered(_, callback, count + 1), 10)
    }
  }

  public unload () {
    const {__cmp: cmp} = window

    delete window.__cmp
    API.provision()

    for (const queueCommand of cmp.a) {
      window.__cmp.a.push(queueCommand)
    }

    if (!this.iframe) {
      this.iframe!.remove()
    }
  }
}
